import { http, HttpResponse } from 'msw';

const baseUrl = `${process.env.NEXT_PUBLIC_API_BASE_URL}/organizations`;

type OrganizationsRecordType = Required<{
  id: number;
  name: string;
  for_individuals: boolean;
  licenses: Array<{
    name: string;
    starts_at: string;
    ends_at: string;
  }> | null;
}>;

const organizationsRecords: OrganizationsRecordType[] = [
  {
    id: 1,
    name: '組織1',
    for_individuals: false,
    licenses: [
      {
        name: 'Assessment',
        starts_at: '2023-10-01T01:00:00+09:00',
        ends_at: '2024-03-31T10:00:00+09:00',
      },
      {
        name: '講座',
        starts_at: '2023-08-01T01:00:00+09:00',
        ends_at: '2023-12-31T10:00:00+09:00',
      },
    ],
  },
  {
    id: 2,
    name: '組織2',
    for_individuals: false,
    licenses: [
      {
        name: 'ライセンス',
        starts_at: '2023-01-01T01:00:00+09:00',
        ends_at: '2023-09-30T10:00:00+09:00',
      },
    ],
  },
  {
    id: 3,
    name: '組織3',
    for_individuals: false,
    licenses: null,
  },
];

type OrganizationRecordType = Required<{
  id: number;
  name: string;
  company_name: string | null;
  sso_only: boolean;
  for_individuals: boolean;
  user_inquiry_form_url: string | null;
}>;

const organizationRecord: OrganizationRecordType = {
  id: 1,
  name: '組織1',
  company_name: '株式会社組織1',
  sso_only: false,
  for_individuals: true,
  user_inquiry_form_url: null,
};

const signIn = 'sign_in';
const notFoundMessage = `組織が見つかりません。`;

export const organizationsHandlers = [
  // 自身(管理者)が所属する組織一覧取得
  http.get(`${baseUrl}/${signIn}`, (_) => {
    console.group(baseUrl);

    const response = {
      organizations: organizationsRecords,
    };

    console.info(response);
    console.groupEnd();

    return HttpResponse.json(response);
  }),
  // サインイン(組織選択)
  http.post(`${baseUrl}/${signIn}`, async ({ request }) => {
    const createRequest = (await request.json()) as Partial<{
      id: number;
    }>;

    console.table(createRequest);

    const foundRecord = organizationsRecords.find(
      (organization) => organization.id === createRequest.id
    );
    if (foundRecord) {
      return HttpResponse.json({ success: true });
    } else {
      return HttpResponse.json(
        { error_type: 'error', message: notFoundMessage },
        { status: 404 }
      );
    }
  }),
  // 自組織情報取得
  http.get(baseUrl, (_) => {
    console.group(baseUrl);

    console.info(organizationRecord);
    console.groupEnd();

    return HttpResponse.json(organizationRecord);
  }),
  // 自組織に関する Quest サービスが管理する情報取得
  http.get(`${baseUrl}/quest`, (_) => {
    console.group(baseUrl);
    const response = {
      suspend_weekly_report: false,
      suspend_notification: false,
      suspend_notification_log: false,
    };

    console.info(response);
    console.groupEnd();

    return HttpResponse.json(response);
  }),
];
